/**
 * Base URL for sGTM requests: the same-origin path when one is configured,
 * else the vendor host.
 *
 * The path must be root-relative and not protocol-relative — anything else is
 * either off-origin or resolves against the current page, so we fall back to
 * the host rather than emit it.
 */
export const getGtmBaseUrl = (fqdn: string, path: string): string => {
    if (path.startsWith("/") && !path.startsWith("//")) {
        return path;
    }
    return `https://${fqdn}`;
};

/**
 * JUST the GTM JS -- the `<script>` element wrapper is supplied by the caller
 * (`dangerouslySetInnerHTML`, or an imperative `script.text =`). Embedding a
 * literal `<script>...</script>` here nests a `<script>` inside a `<script>`:
 * the HTML parser closes the outer script at the inner `</script>`, so the outer
 * script's body begins with `"<script ..."` and throws "Uncaught SyntaxError:
 * Unexpected token '<'" (GTM never initializes), and the stray trailing tag
 * shifts the rest of the document, breaking hydration. The leading `<!-- ... -->`
 * lines are valid JS (Annex B HTML-like comments), so the IIFE runs as the
 * script body.
 */
export const gtmScript = (baseUrl: string, id: string): string => `
        <!-- Google Tag Manager -->
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        '${baseUrl}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');
        <!-- End Google Tag Manager -->
`;

/** Inner HTML of the no-JS `<noscript>` GTM fallback. */
export const gtmNoscriptIframe = (baseUrl: string, id: string): string =>
    `<iframe src="${baseUrl}/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
